import { useSpring } from '@react-spring/web';

import { useEffectOnChange } from '@sorare/core/src/hooks/state/useEffectOnChange.ts';

import type { CardRevealUIState } from './types.ts';

const idleStyle = {
  opacity: 0,
  y: -100,
};

const pulledStyle = {
  opacity: 1,
  y: 0,
};
export const useUIStyles = (uiState: CardRevealUIState) => {
  const [uiStyles, uiStylesApi] = useSpring(() => ({
    from: uiState === 'idle' ? idleStyle : pulledStyle,
  }));

  useEffectOnChange(uiState, () => {
    if (uiState === 'idle') {
      uiStylesApi.start({
        to: idleStyle,
        immediate: true,
      });
    } else if (uiState === 'pulled') {
      uiStylesApi.start({
        to: pulledStyle,
      });
    }
  });

  return uiStyles;
};
